// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"QJ","modalContent":"RJ","header":"SJ","close":"TJ"};